module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "toc_marker-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/There_Was_a_Crooked_Man2#Contents-A"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "Body-Center para-style-override-3"
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("This one is for sisters everywhere.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82e074b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/There_Was_a_Crooked_Man-3.vue
// module id = 66
// module chunks = 0